@if(isPageRestrictionLoaded) {
<ng-container>
    <div class="ppl-container-body">
        <div class="ppl-container-head">
            <h1 class="page-title-accessibility">Good To Pay Timesheets</h1>
        </div>
        <div class="ppl-container">
            <div class="ppl-content-container">
                <div class="w-100">
                    <ppl-timesheet-filter [filterFields]="fields" (searchEvent)="onSearch($event)"
                        [pageId]="pageId"></ppl-timesheet-filter>
                    <p class="pl-2"> <span class="error-message1">*</span> Atleast one out of the following fields
                        should be populated: <b>Participant Name</b>, <b>Participant PPL ID</b>, <b>Provider Name</b>,
                        <b>Provider PPL ID</b>.</p>
                    <div>
                        <p><strong>Note:</strong></p>
                        <ul>
                            <li>For the <strong>Deny</strong> action, please select the applicable timesheets.</li>
                            <li>The <strong>Deny All</strong> action will deny every timesheet line currently loaded in
                                the grid.</li>
                        </ul>
                    </div>
                </div>
                <div class="table-style">
                    @if(hasSearched) {
                    <ppl-list-table [cols]="cols" [disableSort]="true" [disableSearch]="true" [showCustomSearch]="false"
                        [data]="timesheets" [customDataLoaded]="true"
                        [enableActions]="false" [from]="'timesheet'"
                        [gridTitle]="false" [pagination]="true" [loadPage]="true" (onPageLoad)="onPageLoad($event)"
                        [actionButtons]="actionButtons" (rowDetailEvent)="rowClicked($event)" [enablePageActions]="!isReadOnly"
                         [badgeColumns]="['Application Status']"
                        [listButton]="isReadOnly ? [] : buttons" [timesheetFor]="'goodToPayTimesheet'" (actionInvoked)="gridAction($event)" [onViewUser]="onViewUserClicked">
                    </ppl-list-table>
                    } @else {
                    <div class="alert alert-warning"><strong>No Records Found. </strong>Please change the filters to
                        find the records</div>
                    }
                </div>
            </div>
        </div>
    </div>
</ng-container>
}

<div class="filter-panel">
    <ng-template #pendedDialog let-cancel="cancel">
        <ppl-timesheet-staff-errorcode [errorcodeData]="errorcodeData" (onSaveComplete)="onSaveAdjustment($event)"
            [disabled]="isReadOnly || disableEditingPendedTimesheet"></ppl-timesheet-staff-errorcode>
    </ng-template>
</div>

<ppl-popup-dialog [(isVisible)]="showActionPopup" [title]="title" [isOkText]="okText" (confirm)="handleOk()"
    (cancel)="handleCancel()" [showButtons]="true" [showOkButton]="false" [size]="'medium'" [position]="'center'">

    <form nz-form [formGroup]="timesheetActionForm">
        <!-- Remarks Field -->
        <div nz-row>
            <div nz-col style="margin-left: 8px; margin-right: 8px; width: 100%;">
                <nz-form-item>
                    <nz-form-control>
                        <label for="remarks" class="field-header">Remarks</label>
                        <nz-textarea-count [nzMaxCharacterCount]="10000">
                            <textarea rows="3" nz-input id="remarks" formControlName="remarks"
                                placeholder="Start typing..." [maxlength]="10000"
                                [nzStatus]="timesheetActionForm.get('remarks')?.invalid && timesheetActionForm.get('remarks')?.touched ? 'error' : ''"></textarea>
                        </nz-textarea-count>
                        <div
                            *ngIf="timesheetActionForm.get('remarks')?.invalid && timesheetActionForm.get('remarks')?.touched">
                            <div class="error-message">Please enter remarks.</div>
                        </div>
                    </nz-form-control>
                </nz-form-item>
            </div>
        </div>
    </form>

</ppl-popup-dialog>

<div class="filter-panel">
    <ng-template #confirmationDialog let-cancel="cancel">
        <p> This action will apply to all timesheets that meet the search criteria. Do you want to continue?</p>
    </ng-template>
</div>

<div class="filter-panel">
    <ng-template #warningDialog let-cancel="cancel">
        <p> Atleast one out of the following fields should be populated: Participant Name, Participant PPL ID, Provider Name,
            Provider PPL ID</p>
    </ng-template>
</div>
